import {JsonProperty} from 'json-typescript-mapper';
import { MarketStatus } from './marketdate-status.model';
import { Marketdate } from './marketdate.model';
import { Contact } from './contact.model';
import {MessageActionType} from './message.model';
import {Log} from './log.model';

export enum CommentType {
  None= <any>'None',
  Info= <any>'Info',
  Warning= <any>'Warning',
  Problem= <any>'Problem',
  Success= <any>'Success'
}

export class MarketDateComment {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('commentType')
  public commentType?: CommentType;

  @JsonProperty('userComment')
  public userComment?: string;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('image')
  public image?: string;

  @JsonProperty('image2')
  public image2?: string;

  @JsonProperty('image3')
  public image3?: string;

  @JsonProperty('imageCreated')
  public imageCreated?: string;

  @JsonProperty('image2Created')
  public image2Created?: string;

  @JsonProperty('image3Created')
  public image3Created?: string;

  @JsonProperty('imageContentType')
  public imageContentType?: any;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty({clazz: Contact, name: 'updatedBy'})
  public updatedBy?: Contact;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty('imageUploaded')
  public imageUploaded?: boolean;

  @JsonProperty('image2Uploaded')
  public image2Uploaded?: boolean;

  @JsonProperty('image3Uploaded')
  public image3Uploaded?: boolean;

  @JsonProperty('actionCreated')
  public actionCreated?: string;

  @JsonProperty({clazz: Contact, name: 'actionCreatedBy'})
  public actionCreatedBy?: Contact;

  @JsonProperty('actionComment')
  public actionComment?: string;

  @JsonProperty('actionType')
  public actionType?: string;

  @JsonProperty('actionEmail')
  public actionEmail?: Log;

  constructor() {
    this.id = void 0;
    this.comment = void 0;
    this.commentType = void 0;
    this.userComment = void 0;
    this.created = void 0;
    this.image = void 0;
    this.image2 = void 0;
    this.image3 = void 0;
    this.imageCreated = void 0;
    this.image2Created = void 0;
    this.image3Created = void 0;
    this.imageContentType = void 0;
    this.updated = void 0;
    this.updatedBy = void 0;
    this.status = void 0;
    this.marketdate = void 0;
    this.imageUploaded = void 0;
    this.image2Uploaded = void 0;
    this.image3Uploaded = void 0;
    this.actionCreated = void 0;
    this.actionCreatedBy = void 0;
    this.actionComment = void 0;
    this.actionType = void 0;
    this.actionEmail = void 0;
  }
}

export class MarketDateCommentImages {
  id: number;
  images: MarketDateCommentImage[];
}

export class MarketDateCommentImage {
  id: 'image' | 'image2' | 'image3';
  base64: string;

  constructor(id?, base64?) {
    this.id = id;
    this.base64 = base64;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/market-date-comment.model.ts